import { render, staticRenderFns } from "./RecordFeedbackInterview.vue?vue&type=template&id=370c3258&"
import script from "./RecordFeedbackInterview.vue?vue&type=script&lang=ts&"
export * from "./RecordFeedbackInterview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports